export default __webpack_public_path__ + "static/media/DFSExp.5bd9fb33.md";